import Moment from 'moment'

const state = {
  startDate: Moment().subtract(1, 'month'),
  endDate: Moment().startOf('day'),
  compareStartDate: null,
  compareEndDate: null,
  quickDate: true,
}

const getters = {
  startDate: (state) => helpers.format(state.startDate),
  endDate: (state) => helpers.format(state.endDate),
  compareStartDate: function(state) {
    if (state.compareStartDate){
      return helpers.format(state.compareStartDate)
    } else {
      return null
    }
  },
  compareEndDate: function(state) {
    if (state.compareEndDate){
      return helpers.format(state.compareEndDate)
    } else {
      return null
    }
  },
  quickDateShow: state => state.quickDate
}

const mutations = {
  setStartDate: (state, date) => state.startDate = helpers.validate(state.startDate, date),
  setEndDate: (state, date) => state.endDate = helpers.validate(state.endDate, date),
  setCompareStartDate: (state, date) => state.compareStartDate = helpers.validate(state.compareStartDate, date),
  setCompareEndDate: (state, date) => state.compareEndDate = helpers.validate(state.compareEndDate, date),
  toggleQuickDate: (state, toggle) => {
    state.quickDate = toggle
  }
}

const helpers = {
  format: (date) => Moment(date).format('ll'),
  validate: function(stateDate, date) {
    if (date === null) {
      return null
    }
    var dateMin = new Date('2015', '01', '01')
    var inputDate = Moment(date).toDate()
    if (inputDate > dateMin) {
      return date
    } else {
      return stateDate
    }
  }
}

export default {
  state,
  getters,
  mutations
}
